import { render, staticRenderFns } from "./AccProductReactionListItem.vue?vue&type=template&id=08e58f8b"
import script from "./AccProductReactionListItem.vue?vue&type=script&lang=js"
export * from "./AccProductReactionListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports